<script>
import axios from 'axios'
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'
export default {
  page: {
    title: 'Calendar',
    meta: [{ name: 'description', content: 'The Calendar page.' }],
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      type: 'month',
      focus: '',
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
    }
  },
  mounted() {
    this.$refs.calendar.checkChange()
    this.getEvents()
  },
  methods: {
    getEvents() {
      this.events = []
      axios.get('/api/v1/me/').then((response) => {
        response.data.patient_appointment_details.forEach((child) => {
          const dateValue = new Date(
            child.appointment_date.split('-')[0],
            child.appointment_date.split('-')[1] - 1,
            child.appointment_date.split('-')[2],
            child.appointment_end_time.split(':')[0],
            child.appointment_end_time.split(':')[1],
            child.appointment_end_time.split(':')[2],
            0
          )

          const endTime =
            parseInt(child.appointment_time.split(':')[0]) +
            1 +
            ':' +
            child.appointment_time.split(':')[1] +
            ':' +
            child.appointment_time.split(':')[2]
          this.events.push({
            name: 'Telehealth Meeting',
            color:
              dateValue.getTime() < new Date().getTime()
                ? 'grey darken-1'
                : 'blue',
            timed: true,
            start: child.appointment_date + ' ' + child.appointment_time,
            end:
              child.appointment_date +
              ' ' +
              (child.appointment_end_time
                ? child.appointment_end_time
                : endTime),
            data: child,
            clickable: !(dateValue.getTime() < new Date().getTime()),
          })
        })
      })
    },
    viewDay({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor(event) {
      return event.color
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },

    showEvent({ nativeEvent, event }) {
      if (event.clickable) {
        this.$router.push({
          name: 'event-details',
          params: { eventId: event.data.availability_det_id },
        })
      }
    },
    updateRange({ start, end }) {},
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
  },
}
</script>

<template>
  <v-container>
    <v-row class="mt-1">
      <v-col
        :class="$vuetify.breakpoint.smAndDown ? 'pa-2' : 'pa-8'"
        cols="12"
        xs="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
      >
        <template>
          <v-row class="fill-height">
            <v-col>
              <v-sheet
                height="64"
                :class="$vuetify.breakpoint.smAndDown ? '' : 'px-3'"
              >
                <v-toolbar flat>
                  <v-btn
                    v-if="type === 'day'"
                    :class="$style.backClass"
                    class="mr-2"
                    text
                    color="darken-2"
                    @click="type = 'month'"
                  >
                    <v-icon> mdi-chevron-left </v-icon>Back
                  </v-btn>
                  <v-toolbar-title v-if="$refs.calendar">
                    <h3 :class="$style.currentDate">{{
                      $refs.calendar.title
                    }}</h3>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mr-2"
                    fab
                    text
                    small
                    color="darken-2"
                    @click="prev"
                  >
                    <v-icon> mdi-chevron-left </v-icon>
                  </v-btn>
                  <v-btn fab text small color="darken-2" @click="next">
                    <v-icon> mdi-chevron-right </v-icon>
                  </v-btn>
                </v-toolbar>
              </v-sheet>
              <div :class="$style.calenderClss">
                <v-sheet height="600">
                  <v-calendar
                    ref="calendar"
                    v-model="focus"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :type="type"
                    @click:event="showEvent"
                    @click:more="viewDay"
                    @change="updateRange"
                  ></v-calendar>
                </v-sheet>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.backClass {
  display: inline-flex;
  padding: 0 10px 0 2px !important;
  font-size: 16px !important;
  color: white !important;
  text-align: center !important;
  text-transform: inherit !important;
  vertical-align: middle;
  background-color: #2196f3 !important;
}

.calenderClss {
  padding: 0 30px 30px;
  background: #fff;
}
.currentDate {
  margin-bottom: 5px;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 700;
}
@media screen and (max-width: 959px) {
  .calenderClss {
    padding: 0 15px 30px;
  }
}
@media screen and (max-width: 359px) {
  .currentDate {
    font-size: 20px !important;
  }
}
</style>

<style scoped>
/deep/ .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
  padding: 5px;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  color: #000 !important;
  border-right: none !important;
  border-bottom: 1px solid #ebeff0 !important;
  opacity: 0.5 !important;
}
/deep/
  .theme--light.v-calendar-weekly
  .v-calendar-weekly__head-weekday:last-child {
  border-right: 1px solid #e0e0e0 !important;
}
/deep/
  .theme--light.v-calendar-weekly
  .v-calendar-weekly__head-weekday.v-outside {
  background-color: #fff !important;
}
/deep/ .v-calendar-weekly__day-label .v-btn {
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  text-transform: none;
}
/deep/ .v-calendar-weekly__day-label .v-btn.primary {
  background-color: #252525 !important;
  border-color: #0476d9 !important;
}
/deep/ .theme--light.v-calendar-weekly .v-calendar-weekly__day {
  color: #000;
  border-right: 1px solid #ebeff0 !important;
  border-bottom: 1px solid #ebeff0 !important;
}
/deep/ .theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  background-color: #f4f6f9;
  border-right: 1px solid #ebeff0 !important;
  border-left: 1px solid #ebeff0 !important;
}
/deep/
  .theme--light.v-calendar-weekly
  .v-calendar-weekly__day.v-outside:first-child {
  border-left: none !important;
}
/deep/ .v-btn--fab.v-size--small {
  width: 18px !important;
  height: 18px !important;
  padding: 12px !important;
}
/deep/
  .theme--light.v-calendar-weekly
  .v-calendar-weekly__day.v-outside
  .v-calendar-weekly__day-label
  .v-btn {
  color: #252525 !important;
  background-color: inherit !important ;
  opacity: 0.5 !important;
}
/deep/ .v-calendar .v-event.blue {
  width: 100% !important;
  background-color: #0476d9 !important;
}
</style>
